import { Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierAssignmentPrompt extends Layout {
    textboxReason: Textbox;
    textboxReasonCode: Textbox;
}
